import { render, staticRenderFns } from "./CreateTermModal.vue?vue&type=template&id=53d93f85&scoped=true&"
import script from "./CreateTermModal.vue?vue&type=script&lang=js&"
export * from "./CreateTermModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d93f85",
  null
  
)

export default component.exports